import { AccountAccess } from './accountAccess.enum';
import { FormTypes } from './formTypes.enum';
import { HildaType } from './hildaType.enum';
import { IUser } from './iuser.interface';

export type Errors = { [key: string]: boolean };

export type Types = { [key: string]: FormTypes };

export interface IForm {}
export interface IAccountTypeFields {
  accountType: '' | HildaType | string;
}

type KeyString = { [key: string]: any };

export interface IPersonalInformationIndividualFields extends KeyString {
  firstName: string;
  lastName: string;
  ssn: string;
  dateOfBirth: string;
  phoneNumber: string;
  email: string;
  address: string;
  zipCode?: string,
  city?: string,
  state?: string,
}

export interface IPersonalInformationJointFields extends KeyString {
  firstName: string;
  lastName: string;
  ssn: string;
  dateOfBirth: string;
  phoneNumber: string;
  email: string;
  address: string;
  firstName2: string;
  lastName2: string;
  ssn2: string;
  dateOfBirth2: string;
  phoneNumber2: string;
  email2: string;
  address2: string;
  city2: string;
  state2: string;
  zipCode2: string;
}

export interface IPersonalInformationTrustFields extends KeyString {
  entityName: string;
  taxId: string;
  accountTitle: '' | 'individual' | string;
  phoneNumber: string;
  entityEmail: string;
  address: string;
  trustDocumentURL?: string;
}

export interface IPersonalInformationInstitutionalFields extends KeyString {
  entityName: string;
  accountTitle: '' | 'individual' | string;
  entityType: string;
  phoneNumber: string;
  entityEmail: string;
  address: string;
}

export interface IAccountAccessFields extends KeyString {
  accountAccess: "" | AccountAccess;
  bankABA?: string;
  beneficiaryAccountName?: string;
  beneficiaryAccountNumber?: string;
  ffcffbName?: string;
  ffcffbName2?: string;
  advisorId?: string;
}
export interface ISignatureFields extends KeyString {
  signerName: string;
  signDate: string;
}

export enum VerificationStatus {
  "STARTED" = "STARTED",
  "SUCCESS" = "SUCCESS",
  "PENDING" = "PENDING",
  "FAILED" = "FAILED",
  "ERROR" = "ERROR"
}
export interface IVerificationFields extends KeyString {
  verificationStatus: VerificationStatus;
  plaidClientId: string;
}

export interface ISelfApplyFields
  extends IAccountTypeFields,
    IPersonalInformationIndividualFields,
    IPersonalInformationJointFields,
    IPersonalInformationTrustFields,
    IPersonalInformationInstitutionalFields,
    IAccountAccessFields,
    ISignatureFields,
    IVerificationFields {}

export interface IAdvisorPreFillFields
  extends
    IAccountTypeFields,
    IPersonalInformationIndividualFields,
    IPersonalInformationJointFields,
    IPersonalInformationTrustFields,
    IPersonalInformationInstitutionalFields,
    IAccountAccessFields {
  advisor?: IUser;
}

export interface IHildaPendingFields
  extends IPersonalInformationIndividualFields,
    IPersonalInformationJointFields,
    IPersonalInformationTrustFields,
    IPersonalInformationInstitutionalFields {
  advisor?: IUser;
}

export interface IHildaPendingClientFields
  extends IPersonalInformationIndividualFields,
    IPersonalInformationJointFields,
    IPersonalInformationTrustFields,
    IPersonalInformationInstitutionalFields,
    IAccountAccessFields,
    ISignatureFields,
    IVerificationFields {}

export interface IHildaPendingNotSubmittedFields
  extends IAccountTypeFields,
    IPersonalInformationIndividualFields,
    IPersonalInformationJointFields,
    IPersonalInformationTrustFields,
    IPersonalInformationInstitutionalFields {}

export interface IAwaitingClientApprovalFields
  extends IAccountTypeFields,
    IPersonalInformationIndividualFields,
    IPersonalInformationJointFields,
    IPersonalInformationTrustFields,
    IPersonalInformationInstitutionalFields {
  advisor: IUser;
}
export interface IStepCanAdvance {
  typeOfAccount?: boolean;
  personalInformation?: boolean;
  accountAccess?: boolean;
  termsConditions?: boolean;
  verification?: boolean;
  confirmation?: boolean;
  signature?: boolean;
}
